module.exports = __webpack_public_path__ + "static/media/place-60(2).50626ffb.png";